/**
 * Generate a 6-digit backup code from ticket ID
 * Uses a simple hash function to create a consistent code for each ticket
 */
export function generateTicketCode(ticketId) {
  if (!ticketId) return '000000';
  
  // Convert ticket ID to string and create a hash
  const str = String(ticketId);
  let hash = 0;
  
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Convert to positive 6-digit number
  const code = Math.abs(hash) % 1000000;
  
  // Pad with zeros to ensure 6 digits
  return String(code).padStart(6, '0');
}

/**
 * Format the 6-digit code with spaces for better readability (XXX XXX)
 */
export function formatTicketCode(code) {
  if (!code || code.length !== 6) return code;
  return `${code.slice(0, 3)} ${code.slice(3)}`;
}
